import pageMeasureService from "../measure/PageMeasureService";
import elementService from "../../../js/common/ElementService";

interface DatalayerEcommerceItem {
    [key: string]: unknown;

    item_id: number;  // eslint-disable-line @typescript-eslint/naming-convention
}

interface ItemsDataLayerItem extends Record<string, unknown> {
    [key: string]: unknown;

    event: string;
    ecommerce?: {
        items: DatalayerEcommerceItem[];
    };
}

export default new class ProductCardClickService {
    public initForContainer(element: HTMLElement): void {
        this.initProductDetailBrowseClick(element);
        this.initSelectItemDataLayerPushes(element);
    }

    private initProductDetailBrowseClick(element: HTMLElement): void {
        for (const productDetailButton of element.querySelectorAll<HTMLElement>(".js-product-detail-browse")) {
            productDetailButton.addEventListener("click", (event: MouseEvent) => this.browseToProduct(event.ctrlKey, productDetailButton));
        }
    }

    private browseToProduct(ctrlKey: boolean, productDetailButton: HTMLElement): void {
        const productUrl = elementService.elementData(productDetailButton, "productUrl");

        if (ctrlKey) {
            window.open(productUrl, "_blank");
        } else {
            globalThis.location.href = productUrl;
        }
    }

    private initSelectItemDataLayerPushes(element: HTMLElement): void {
        for (const selectItemButton of element.querySelectorAll<HTMLDivElement | HTMLAnchorElement>("div[data-detail-link-package-id], a[data-detail-link-package-id]")) {
            selectItemButton.addEventListener("click", () => this.pushSelectItemDataLayer(selectItemButton));
        }
    }

    private pushSelectItemDataLayer(selectItemButton: HTMLDivElement | HTMLAnchorElement): void {
        const packageId = Number.parseInt(elementService.elementData(selectItemButton, "detailLinkPackageId"));

        const dataLayerItem = this.findDataLayerItem(packageId);

        if (dataLayerItem === undefined) {
            return;
        }

        pageMeasureService.sendDataLayer(
            [
                {
                    ecommerce: null,  // eslint-disable-line unicorn/no-null
                },
            ],
        );

        pageMeasureService.sendDataLayer([
            {
                event: "select_item",
                ecommerce: {
                    items: [dataLayerItem],
                },
            },
        ]);
    }

    private findDataLayerItem(packageId: number): DatalayerEcommerceItem | undefined {
        for (const dataLayerItem of window.dataLayer as ItemsDataLayerItem[]) {
            if (dataLayerItem.event !== "view_item_list") {
                continue;
            }

            if (dataLayerItem.ecommerce?.items === undefined) {
                continue;
            }

            for (const dataLayerItemProduct of dataLayerItem.ecommerce.items) {
                if ("item_id" in dataLayerItemProduct && dataLayerItemProduct.item_id === packageId) {
                    return dataLayerItemProduct;
                }
            }
        }

        return undefined;
    }
}();
